import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=c7be370c&scoped=true"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"
import style0 from "./KPICard.vue?vue&type=style&index=0&id=c7be370c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7be370c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7be370c')) {
      api.createRecord('c7be370c', component.options)
    } else {
      api.reload('c7be370c', component.options)
    }
    module.hot.accept("./KPICard.vue?vue&type=template&id=c7be370c&scoped=true", function () {
      api.rerender('c7be370c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/KPICard.vue"
export default component.exports